import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon, MapPin, PartyPopper } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function HeroSearch({ compact = false }) {
    const nav = useNavigate();
    const [event, setEvent] = useState("");
    const [where, setWhere] = useState("");

    const submit = (e) => {
        e?.preventDefault?.();
        const p = new URLSearchParams();
        if (event) p.set("q", event);
        if (where) p.set("city", where);
        nav(`/search?${p.toString()}`);
    };

    return (
        <form
            onSubmit={submit}
            className={`glass rounded-2xl border border-white/30 shadow-2xl shadow-black/10 p-2 md:p-2.5 flex flex-col md:flex-row gap-2 md:gap-1 ${compact ? "max-w-3xl" : "max-w-3xl"} w-full`}
            data-testid="hero-search-form"
        >
            <div className="flex items-center gap-3 flex-1 px-4 py-3 md:py-2 rounded-xl hover:bg-muted/50 transition-colors">
                <PartyPopper className="h-5 w-5 text-secondary shrink-0" />
                <div className="flex-1">
                    <label className="block text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">What are you planning?</label>
                    <Input
                        value={event}
                        onChange={(e) => setEvent(e.target.value)}
                        placeholder="Birthday party, private dining, wedding…"
                        className="h-8 border-0 shadow-none px-0 focus-visible:ring-0 text-base placeholder:text-muted-foreground/60 bg-transparent"
                        data-testid="hero-input-event"
                    />
                </div>
            </div>
            <div className="hidden md:block w-px bg-border/70 my-2" />
            <div className="flex items-center gap-3 flex-1 px-4 py-3 md:py-2 rounded-xl hover:bg-muted/50 transition-colors">
                <MapPin className="h-5 w-5 text-primary shrink-0" />
                <div className="flex-1">
                    <label className="block text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Where?</label>
                    <Input
                        value={where}
                        onChange={(e) => setWhere(e.target.value)}
                        placeholder="London, New York, Sydney…"
                        className="h-8 border-0 shadow-none px-0 focus-visible:ring-0 text-base placeholder:text-muted-foreground/60 bg-transparent"
                        data-testid="hero-input-where"
                    />
                </div>
            </div>
            <Button type="submit" className="rounded-xl h-14 md:h-auto px-6 md:px-8 bg-primary hover:bg-primary/90 text-primary-foreground gap-2" data-testid="hero-search-button">
                <SearchIcon className="h-5 w-5" />
                <span className="font-semibold">Search venues</span>
            </Button>
        </form>
    );
}
